import { render } from "./PermissaoExecutor.vue?vue&type=template&id=c9ad825a&scoped=true"
import script from "./PermissaoExecutor.vue?vue&type=script&lang=js"
export * from "./PermissaoExecutor.vue?vue&type=script&lang=js"

import "./PermissaoExecutor.vue?vue&type=style&index=0&id=c9ad825a&lang=css"
import "./PermissaoExecutor.vue?vue&type=style&index=1&id=c9ad825a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ad825a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QSelect,QTable,QImg,QTd,QPagination,QCard,QIcon,QScrollArea,QField});
